import React, { useContext, useEffect, useRef } from "react";
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import ToastContext from "../Context/toastContext"; 
import './Component.css'

const Toast = () => {
  const { toast } = useContext(ToastContext); 
  const toastRef = useRef(null);

  useEffect(() => {
    if (toast.show && toastRef.current) {
      toastRef.current.show();
    }
  }, [toast]);

  return (
    <div>
      <ToastComponent
        ref={toastRef}
        title={toast.type}
        content={toast.message}
        position={{ X: "Right", Y: "Top" }}
        showCloseButton={true}
        timeOut={4000} 
        cssClass="custom-toast"
      />
    </div>
  );
};

export default Toast;
